import React, { useEffect, useState } from 'react';
import {
	makeStyles,
	Button,
	MenuItem,
	LinearProgress,
	Box,
	TextField,
	InputAdornment,
	Grid,
	Tabs,
	Tab,
	Divider,
	withStyles,
	FormControlLabel,
	Checkbox,
	Radio,
	RadioGroup,
	FormControl,
} from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateRangePicker from '@mui/lab/DateRangePicker';

// import { TextField } from 'formik-material-ui';
// import TextField from '@material-ui/core/TextField
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Field, Form, Formik } from 'formik';
import PhoneIcon from '@material-ui/icons/Phone';
import TitleText from '../../components/reusableComponents/TitleText';
import { useMediaQuery, useTheme } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import BodyText from './BodyText';
import EmailIcon from '@material-ui/icons/Email';
import LockIcon from '@material-ui/icons/Lock';
// import Autocomplete from 'react-autocomplete';
import Autocomplete from '@mui/material/Autocomplete';
import flt from '../../assets/images/flt.png';
import { useDispatch, useSelector } from 'react-redux';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import '../../../node_modules/react-day-picker/lib/style.css';
import { formatDate, parseDate } from 'react-day-picker/moment';
import moment from 'moment';
import Helmet from 'react-helmet';
import {
	SearchFormDispatch,
	SearchReturnFormDispatch,
} from '../../reducers/HomeReducer';
import { useHistory, useLocation } from 'react-router-dom';
import Range from './Range';
import P from './P';
import RangeInternal from './RangeInternal';
import DateRange from './DateRange';
import DateRangeRound from './DateRangeRound';
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 25,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 25,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: '#39c9bb',
		color: 'white',
		borderRadius: 25,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: '#39c9bb',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	auto: {
		'& input': {
			padding: '20px 18px',
		},
		'& div': {
			'& div': {
				// position: 'fixed',
				// maxHeight: '20%',
				// left: 'none',
				padding: 3,
			},
		},
		'& .css-xrz6uu-MuiAutocomplete-root .MuiInput-root .MuiInput-input': {
			padding: '11px 4px 4px 0px',
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},
		'& .MuiFormLabel-root': {
			marginLeft: 5,
			fontSize: 13,
		},
		'& .css-qzbt6i-MuiButtonBase-root-MuiIconButton-root-MuiAutocomplete-popupIndicator':
			{
				marginTop: -10,
			},
	},
	root: {
		'& .InputFromTo': {
			'& .DayPickerInput input': {
				padding: '20px 18px',
			},
		},
	},
	j: {
		'& .MuiBox-root': {
			// alignContent: 'stretch',
			// justifyContent: 'flex-start',
			// flexWrap: 'wrap',
			// display: 'flex',
			display: 'flex',
			alignContent: 'stretch',
			flexWrap: 'wrap',
		},
	},
	down: {
		// opacity: 1,

		// position: 'absolute',
		// top: '100%',
		// left: 0,
		marginTop: '385px',
		minWidth: 300,
		padding: 10,
		background: 'white',
		position: 'absolute',
		zIndex: 1,
		boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
		// opacity: 0,
		// transform: 'scaleY(0)',
		transformOrigin: 'top',
		transition: 'all .3s ease',
		'@media(min-device-width: 500px) and (max-device-width: 1120px)': {
			marginLeft: 137,
		},
	},
}));

const SearchForm = ({ item }) => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const [from, setFrom] = useState(undefined);
	const [to, setTo] = useState(undefined);
	const { city } = useSelector((state) => state.home);
	const { origin, depart, FormData, originO, departO } = useSelector(
		(state) => state.ui
	);
	const [data, setData] = useState(false);
	const [result, setResult] = useState([]);
	const [result2, setResult2] = useState([]);
	const [value, setValue] = useState('Economy');
	const [adult, setAdult] = useState(FormData && FormData.AdultCount);
	const [child, setChild] = useState(FormData && FormData.ChildCount);
	const [infant, setInfant] = useState(FormData && FormData.InfantCount);
	const theme = useTheme();
	const location = useLocation();
	const converts = (str) => {
		var monthNames = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];
		var fromDate = new Date(str);

		var date =
			monthNames[fromDate.getMonth()] +
			' ' +
			fromDate.getDate() +
			',' +
			' ' +
			fromDate.getFullYear();
		return date;
		// alert(date);
		// console.log(date);
	};

	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	const [value2, setValue2] = React.useState([null, null]);
	const showFromMonth = () => {
		if (!from) {
			return;
		}
		if (moment(to).diff(moment(from), 'months') < 2) {
			to.getDayPicker().showMonth(from);
		}
	};
	const handleToChange = (to) => {
		setTo(showFromMonth(to));
		console.log('first');
	};
	const handleFromChange = (from) => {
		setFrom(from);
	};
	const handleRadio = (event) => {
		setValue(event.target.value);
	};
	const handleSubmit = (data) => {
		console.log(data);

		let formData = {
			JourneyType: 1,
			Origin: data.Origin,
			Destination: data.Destination,
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			PreferredDepartureTime: origin,
		};

		// dispatch(SearchFormDispatch(formData, history));
		console.log(formData);
	};
	const modifiers = { start: from, end: to };

	let invoiceOptions = [];
	let demo = [];
	city &&
		city.data &&
		city.data.length > 0 &&
		city.data.forEach((invoice, index) => {
			// if (index < 100) {
			invoiceOptions.push({
				code: invoice.iata_code,
				city: invoice.city,
				country: invoice.country_name,
			});
			// }
			if (index < 50) {
				demo.push({
					code: invoice.iata_code,
					city: invoice.city,
					country: invoice.country_name,
				});
			}
		});
	// console.log(location.state);
	console.log(invoiceOptions);
	const handleSearch = (event) => {
		let value = event.target.value.toLowerCase();
		// let results = [];
		console.log(value);
		if (value.length >= 2) {
			// results =
			// 	invoiceOptions &&
			// 	invoiceOptions.filter((data) => {
			// 		return data.city.search(value) != -1;
			// 	});
			// setResult(results);
			let results =
				invoiceOptions &&
				invoiceOptions.filter((data) => {
					// const regex = new RegExp(`${value}`, 'gi');
					// return (
					// 	data.code.match(regex) ||
					// 	data.city.match(regex) ||
					// 	data.country.match(regex)
					// );
					return Object.values(data).join('').toLowerCase().includes(value);
				});
			setResult(results);
		} else {
			setResult([]);
		}
	};

	const handleSearch2 = (event) => {
		let value = event.target.value.toLowerCase();
		let results = [];
		console.log(value);
		if (value.length >= 2) {
			// results =
			// 	invoiceOptions &&
			// 	invoiceOptions.filter((data) => {
			// 		return data.city.search(value) != -1;
			// 	});
			// setResult(results);
			results =
				invoiceOptions &&
				invoiceOptions.filter((data) => {
					return Object.values(data).join('').toLowerCase().includes(value);
				});
			setResult2(results);
		} else {
			setResult2([]);
		}
	};
	console.log(result);
	console.log(FormData);
	// console.log(location.state ? location.state.form.Origin : '');
	return (
		<>
			<Formik
				initialValues={{
					Origin: {
						code: FormData && FormData.Origin,
						city: 'dfedf',
						country: 'edfe',
					},
					Destination: 'CCU',
				}}
				validate={(values) => {
					const errors = {};
				}}
				enableReinitialize={true}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting, setFieldValue, values }) => (
					<>
						<Form className={classes.j}>
							<Box display='flex'>
								<Grid container spacing={matches ? 2 : ''}>
									<Grid item xs={12} sm={6} lg={2}>
										<div className={classes.auto}>
											{/* <Autocomplete
										className='auto'
										getItemValue={(item) => item.citycode}
										items={city && city.data ? city && city.data : []}
										renderItem={(item, isHighlighted) => (
											<Box
												display='flex'
												justifyContent='space-between'
												style={{
													minWidth: 320,
													background: 'white',
													padding: 10,
													// minHeight: 200,
													// boxShadow: '0 2px 10px rgb(0 0 0 / 18%)',
													maxHeight: 50,
												}}>
												<Box>
													<TitleText one>{item.citycode}</TitleText>
													<BodyText one>{item.cityname}</BodyText>
												</Box>
												<BodyText>{item.countrycode}</BodyText>
											</Box>
										)}
										value={values.Origin}
										onChange={(e) => setFieldValue('Origin', e.target.value)}
										onSelect={(val) => setFieldValue('Origin', val)}
									/> */}
											<Autocomplete
												id='country-select-demo'
												sx={{
													// width: 230,
													background: 'white',
													border: '1px solid grey',
												}}
												options={result && result.length > 0 ? result : []}
												autoHighlight
												getOptionLabel={(option) => option.code}
												defaultValue={{
													code: FormData && FormData.Origin,
													city: 'dfedf',
													country: 'edfe',
												}}
												renderOption={(props, option) => (
													<Box
														component='li'
														sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
														{...props}>
														<img
															loading='lazy'
															width='20'
															src={flt}
															// srcSet={`https://flagcdn.com/w40/in.png 2x`}
															alt=''
														/>
														{option.city} ({option.code}) {option.country}
													</Box>
												)}
												onChange={(event, value) =>
													setFieldValue('Origin', value.code)
												}
												renderInput={(params) => (
													<TextField
														{...params}
														label='Leaving From'
														onChange={handleSearch}
														name='origin'

														// inputProps={{
														// 	...params.inputProps,
														// 	autoComplete: 'new-password', // disable autocomplete and autofill
														// }}
													/>
												)}
												// value={values.Origin}
												// onChange={(e) => console.log(e.target.value)}
												// onSelect={(val) => setFieldValue('Origin', val)}
											/>
										</div>
									</Grid>
									<Grid item xs={12} sm={6} lg={2}>
										{' '}
										<div className={classes.auto}>
											<Autocomplete
												id='country-select-demo'
												sx={{
													// width: 230,
													background: 'white',
													border: '1px solid grey',
												}}
												options={result2 && result2.length > 0 ? result2 : []}
												defaultValue={{
													code: FormData && FormData.Destination,
													city: 'dfedf',
													country: 'edfe',
												}}
												autoHighlight
												getOptionLabel={(option) => option.code}
												renderOption={(props, option) => (
													<Box
														component='li'
														sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
														{...props}>
														<img loading='lazy' width='20' src={flt} />
														{option.city} ({option.code}) {option.country}
													</Box>
												)}
												onChange={(event, value) =>
													setFieldValue('Destination', value.code)
												}
												renderInput={(params) => (
													<TextField
														{...params}
														label='Going To'
														onChange={handleSearch2}
														// inputProps={{
														// 	...params.inputProps,
														// 	autoComplete: 'new-password', // disable autocomplete and autofill
														// }}
													/>
												)}
												// value={values.Origin}
												// onChange={(e) =>
												// 	setFieldValue('Destination', e.target.value)
												// }
												// onSelect={(val) => setFieldValue('Origin', val)}
											/>
											{/* <Autocomplete
										getItemValue={(item) => item.citycode}
										items={city && city.data ? city && city.data : []}
										renderItem={(item, isHighlighted) => (
											<Box
												display='flex'
												justifyContent='space-between'
												style={{
													minWidth: 320,
													background: 'white',
													padding: 10,
													// minHeight: 200,
													// boxShadow: '0 2px 10px rgb(0 0 0 / 18%)',
													maxHeight: 100,
												}}>
												<Box>
													<TitleText one>{item.citycode}</TitleText>
													<BodyText one>{item.cityname}</BodyText>
												</Box>
												<BodyText>{item.countrycode}</BodyText>
											</Box>
										)}
										value={values.Destination}
										onChange={(e) =>
											setFieldValue('Destination', e.target.value)
										}
										onSelect={(val) => setFieldValue('Destination', val)}
									/> */}
										</div>
										{/* <LocalizationProvider dateAdapter={AdapterDateFns}>
									<div>
										<DateRangePicker
											calendars={2}
											value={value2}
											onChange={(newValue) => {
												setValue2(newValue);
											}}
											renderInput={(startProps, endProps) => (
												<React.Fragment>
													<TextField {...startProps} />
													<Box sx={{ mx: 2 }}> to </Box>
													<TextField {...endProps} />
												</React.Fragment>
											)}
										/>
									</div>
								</LocalizationProvider> */}
									</Grid>
									<Grid item xs={12} sm={12} lg={4}>
										{/* <Rangedispatch={dispatch} matches={matches} /> */}
										{/* <RangeInternal
											dispatch={dispatch}
											matches={matches}
											loc={originO ? converts(originO) : ''}
											dep={departO ? converts(departO) : ''}
										/> */}
										<DateRangeRound />
									</Grid>
									<Grid item xs={12} sm={6} lg={2}>
										<Box
											style={{
												padding: '14px 14px',
												backgroundColor: 'white',
												border: '1px solid gray',
											}}
											display='flex'
											justifyContent='space-between'
											alignItems='center'>
											<BodyText one>
												1 Traveller(s)<span>|</span>Economy
											</BodyText>
											<ExpandMoreIcon
												style={{
													transform: data ? 'rotate(180deg)' : '',
													transition: 'all .3s',
												}}
												onClick={() => {
													data ? setData(false) : setData(true);
												}}
											/>
											<div
												className={classes.down}
												style={{
													transform: data ? 'scaleY(0.85)' : 'scaleY(0)',
												}}>
												<Box
													display='flex'
													justifyContent='space-between'
													textAlign='center'
													mt={'5px'}>
													<BodyText>Adult</BodyText>
													<Box display='flex'>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																border: 0,
																cursor: 'pointer',

																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}
															onClick={() =>
																adult === 0 ? '' : setAdult(adult - 1)
															}>
															<BodyText
																textStyle={{
																	marginTop: 8,
																	color: adult === 0 ? 'wheat' : '',
																}}>
																-
															</BodyText>
														</Box>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																border: 0,
																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}>
															<BodyText textStyle={{ marginTop: 8 }}>
																{adult}
															</BodyText>
														</Box>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																cursor: 'pointer',

																border: 0,
																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}
															onClick={() =>
																adult === 9 ? '' : setAdult(adult + 1)
															}>
															<BodyText
																textStyle={{
																	marginTop: 8,
																	color: adult === 9 ? 'wheat' : '',
																}}>
																+
															</BodyText>
														</Box>
													</Box>
												</Box>
												<Box
													display='flex'
													justifyContent='space-between'
													textAlign='center'
													mt={'5px'}>
													<BodyText>Child</BodyText>
													<Box display='flex'>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																border: 0,
																cursor: 'pointer',

																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}
															onClick={() =>
																child === 0 ? '' : setChild(child - 1)
															}>
															<BodyText
																textStyle={{
																	marginTop: 8,
																	color: child === 0 ? 'wheat' : '',
																}}>
																-
															</BodyText>
														</Box>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																border: 0,
																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}>
															<BodyText textStyle={{ marginTop: 8 }}>
																{child}
															</BodyText>
														</Box>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																cursor: 'pointer',

																border: 0,
																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}
															onClick={() =>
																child === 9 ? '' : setChild(child + 1)
															}>
															<BodyText
																textStyle={{
																	marginTop: 8,
																	color: child === 9 ? 'wheat' : '',
																}}>
																+
															</BodyText>
														</Box>
													</Box>
												</Box>
												<Box
													display='flex'
													justifyContent='space-between'
													textAlign='center'
													mt={'5px'}>
													<BodyText>Infant</BodyText>
													<Box display='flex'>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																border: 0,
																cursor: 'pointer',
																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}
															onClick={() => setInfant(infant - 1)}>
															<BodyText textStyle={{ marginTop: 8 }}>
																-
															</BodyText>
														</Box>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																border: 0,
																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}>
															<BodyText textStyle={{ marginTop: 8 }}>
																{infant}
															</BodyText>
														</Box>
														<Box
															style={{
																display: 'block',
																float: 'left',
																width: '40px',
																height: '40px',
																lineHeight: '40px',
																background: 'white',
																textAlign: 'center',
																borderRadius: 0,
																padding: 0,
																border: 0,
																cursor: 'pointer',

																boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
															}}
															onClick={() => setInfant(infant + 1)}>
															<BodyText textStyle={{ marginTop: 8 }}>
																+
															</BodyText>
														</Box>
													</Box>
												</Box>
												<Box
													display='flex'
													alignItems='self-end'
													justifyContent='space-between'>
													<Box>
														<FormControl component='fieldset'>
															{/* <FormLabel component='legend'>Gender</FormLabel> */}
															<RadioGroup
																aria-label='gender'
																name='gender1'
																value={value}
																onChange={handleRadio}>
																<FormControlLabel
																	value='Economy'
																	control={<Radio />}
																	label='Economy'
																/>
																<FormControlLabel
																	value='Business'
																	control={<Radio />}
																	label='Business'
																/>
																<FormControlLabel
																	value='First Class'
																	control={<Radio />}
																	label='First Class'
																/>
																<FormControlLabel
																	value='Premium Economy'
																	control={<Radio />}
																	label='Premium Economy'
																/>
															</RadioGroup>
														</FormControl>
													</Box>
													<Box
														onClick={() => {
															data ? setData(false) : setData(true);
														}}
														style={{
															padding: 10,
															backgroundColor: '#39c9bb',
															cursor: 'pointer',
														}}>
														<BodyText textStyle={{ color: 'white' }}>
															Done
														</BodyText>
													</Box>
												</Box>
											</div>
										</Box>
									</Grid>
									<Grid item xs={12} sm={6} lg={2}>
										<button
											type='submit'
											disabled={isSubmitting}
											style={{
												cursor: 'pointer',
												padding: '13px 50px',
												backgroundColor: '#39c9bb',
												color: 'white',
												width: '100%',
											}}>
											<TitleText two>SEARCH</TitleText>
										</button>
									</Grid>
								</Grid>

								{/* <P /> */}
							</Box>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default SearchForm;
